module.exports = __webpack_public_path__ + "img/lg_ring_y_0_0_null.c2a8718e.png";